export const ValidarMembresia = (membresia, entradas) => {
  let now = new Date();
  let nowMonth = now.getMonth() + 1;
  let nowYear = now.getFullYear();

  if (membresia.monto_limite <= 0) {
    return false;
  }

  if (membresia.limit <= 0) {
    return false;
  }

  if (membresia.year == nowYear) {
    if (membresia.cycle == nowMonth) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }

  /*
    let cantidadTotal = 0;
    let total = 0;
    entradas.map((entrada) => {
        if(entrada.quantity){
            cantidadTotal = parseInt(entrada.quantity) + cantidadTotal;
            total = (parseInt(entrada.quantity) * entrada.precio) + total;
        }
    })


    if(total <= 0){
        return false;
    }

    if(membresia.limit < cantidadTotal){
        return false;
    } */

  return true;
};

export const profit = ({ evento, membresia, cupon }) => {
  let totalCupon = null;
  const result = structuredClone(evento);

  if (!membresia) {
    if (cupon.data) {
      if (cupon.data) {
        totalCupon =
          result.info.total - (result.info.total / 100) * cupon.data.descuento;
      }
      let info = {
        ...result.info,
        totalCupon: totalCupon,
      };
      result.info = info;
      return result;
    }
    return result;
  }

  let _total = 0;
  let _subTotal = 0;
  let _serv = 0;
  let descont = membresia.descont;
  let limit = membresia.limit;
  let comision = result.evento.comisiones.tasa;
  let entradaMembresia = {};


  let entradas = result.evento.entradas.map((entrada) => {
    if (entrada.hasOwnProperty("quantity")) {
      if (entrada.quantity <= limit) {

        console.log('entradaMembresia 1', entrada)

        let descuento_aplicado = 0;
        let subtotal_price = limit * parseFloat(entrada.precio)

        descuento_aplicado = (subtotal_price / 100) * descont;
        subtotal_price = subtotal_price - descuento_aplicado;

        let serv = 0;
        let subTotal = 0;
        let pricexquantity = 0;

        pricexquantity = limit * subtotal_price;
        subTotal = subtotal_price;
        serv = (subtotal_price / 100) * comision;

        _total = _total + subTotal + serv;
        _subTotal = _subTotal + subTotal;
        _serv = _serv + serv;

        return {
          ...entrada,
          nombre: `${entrada.nombre} | ${membresia.name}`,
          quantity: entrada.quantity,
          pricexquantity: subtotal_price,
          serv: (subtotal_price / 100) * comision,
          subTotal: subtotal_price,
          membresia: membresia.code,
        };
      }

      if (entrada.quantity > limit && limit > 0) {
        let descuento_aplicado = 0;
        let subtotal_price = limit * parseFloat(entrada.precio)

        descuento_aplicado = (subtotal_price / 100) * descont;
        subtotal_price = subtotal_price - descuento_aplicado;

        entradaMembresia = {
          ...entrada,
          nombre: `${entrada.nombre} | ${membresia.name}`,
          quantity: limit,
          pricexquantity: subtotal_price,
          serv: (subtotal_price / 100) * comision,
          subTotal: subtotal_price,
          membresia: membresia.code,
        };

        console.log('entradaMembresia 2', entradaMembresia)

        let quantity = entrada.quantity - limit;
        let serv = 0;
        let subTotal = 0;
        let pricexquantity = 0;


        pricexquantity = subtotal_price;
        subTotal = (quantity * entrada.precio) + subtotal_price;
        serv = (((quantity * entrada.precio) / 100) * comision) + (subtotal_price / 100) * comision;

        _total = _total + subTotal + serv;
        _subTotal = _subTotal + subTotal;
        _serv = _serv + serv;

        limit = 0;
        return {
          ...entrada,
          quantity: Math.abs(quantity),
          pricexquantity: pricexquantity,
          serv: serv,
          subTotal: subTotal,
        };
      }

      console.log('entrada sin membresia', entrada)

      let quantity = entrada.quantity - limit;
      let serv = 0;
      let subTotal = 0;
      let pricexquantity = 0;

      pricexquantity = Math.abs(quantity) * parseFloat(entrada.precio);
      subTotal = parseFloat(entrada.precio);
      serv = subTotal / 100 * comision;

      _total = _total + subTotal + serv;
      _subTotal = _subTotal + subTotal;
      _serv = _serv + serv;

      return {
        ...entrada,
        quantity: Math.abs(quantity),
        pricexquantity: pricexquantity,
        serv: serv,
        subTotal: subTotal,
      };
    } else {
      return entrada;
    }
  });


  entradas.push(entradaMembresia);

  totalCupon = null;

  if (cupon.data) {
    totalCupon = _total - (_total / 100) * cupon.data.descuento;
  }

  let info = {
    serv: _serv,
    subTotal: _subTotal,
    total: _total,
    totalCupon: totalCupon,
  };

  console.log('info', info)

  result.evento.entradas = entradas;
  result.info = info;
  return result;
};
